import { resourceReducer, getResources, getStatus } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const purchases = resourceReducer('purchases', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default purchases;

export const getUserPurchases = (state, page = 1) =>
  getResources(state, `userPurchases${page}`);
export const getUserCancelledPurchases = (state, page = 1) =>
  getResources(state, `userCancelledPurchases${page}`);
export const getUserCancelledPurchasesStatus = (state, page = 1) =>
  getStatus(state, `requests.fetchCancelledByUser${page}.status`);

export const getBlankInvoice = (state) => getResources(state, 'blankInvoice');
export const getSpecificUserPurchases = (state, page = 1) =>
  getResources(state, `specificUserPurchases${page}`);
export const getOverduePurchases = (state) =>
  getResources(state, `userOverduePurchases`);
export const getPurchaseContractsByUserId = (state, purchaseId) =>
  getResources(state, `purchaseContractByUserId${purchaseId}`);
export const getPurchase = (state, purchaseId) =>
  getResources(state, [purchaseId])[0];
export const getPurchaseNotFound = (state, purchaseId) =>
  state.meta[purchaseId] && state.meta[purchaseId].readStatusCode === 404;
export const getCreateBuyoutPurchaseFullErrorMessage = (state) =>
  state.requests &&
  state.requests.createBuyoutPurchase &&
  state.requests.createBuyoutPurchase.fullErrorMessage;
export const getPartialRefundErrorMessage = (state) =>
  state.requests &&
  state.requests.partialRefund &&
  state.requests.partialRefund.fullErrorMessage &&
  state.requests.partialRefund.fullErrorMessage;
export const getCreateBuyoutPurchaseId = (state) =>
  state.requests &&
  state.requests.createBuyoutPurchase &&
  state.requests.createBuyoutPurchase.ids &&
  state.requests.createBuyoutPurchase.ids[0];
export const getCreateBuyoutPurchaseStatus = (state) =>
  getStatus(state, `requests.createBuyoutPurchase.status`);
export const getUpgradePurchaseId = (state) => {
  return (
    state.requests &&
    state.requests.upgradePlan &&
    state.requests.upgradePlan.ids &&
    state.requests.upgradePlan.ids[0]
  );
};
export const getAttUpgradePurchaseId = (state) =>
  state.requests &&
  state.requests.upgradeAttPlan &&
  state.requests.upgradeAttPlan.ids &&
  state.requests.upgradeAttPlan.ids[0];

export const getTracfoneUpdatePlanInvoice = (state) =>
  state.requests &&
  state.requests.generateTracfonePlanInvoice &&
  state.requests.generateTracfonePlanInvoice.ids &&
  state.requests.generateTracfonePlanInvoice.ids[0];

export const getSimoTopUpUpgradePurchaseId = (state) =>
  state.requests &&
  state.requests.upgradeSimoTopUp &&
  state.requests.upgradeSimoTopUp.ids &&
  state.requests.upgradeSimoTopUp.ids[0];

export const getSimoUpgradePurchaseId = (state) =>
  state.requests &&
  state.requests.upgradeSimoPlan &&
  state.requests.upgradeSimoPlan.ids &&
  state.requests.upgradeSimoPlan.ids[0];

export const getQuickUpgradePurchaseId = (state) =>
  state.requests &&
  state.requests.upgradeQuickPlan &&
  state.requests.upgradeQuickPlan.ids &&
  state.requests.upgradeQuickPlan.ids[0];

export const getSearchPurchases = (state, page = 1) =>
  getResources(state, `searchPage${page}`);
export const getPendingArrangement = (state, page = 1) =>
  getResources(state, `pendingArrangements${page}`);
export const getRefundAffirmErrorMessage = (state) =>
  state.requests &&
  state.requests.refundAffirm &&
  state.requests.refundAffirm.error;

export const getPurchaseLineItems = (state, purchaseId, page = 1) => {
  const purchaseMeta =
    state.meta[purchaseId] && state.meta[purchaseId].lineItems;
  if (purchaseMeta && purchaseMeta[`results${page}`]) {
    return purchaseMeta[`results${page}`];
  }

  if (page.toString() === '1') {
    const purchase = getResources(state, [purchaseId])[0];
    return purchase ? purchase.line_items : [];
  }

  return [];
};

export const getPurchaseLineItemsCount = (state, purchaseId) => {
  const purchaseMeta =
    state.meta[purchaseId] && state.meta[purchaseId].lineItems;
  if (purchaseMeta && typeof purchaseMeta.count !== 'undefined') {
    return purchaseMeta.count;
  }

  const purchase = getResources(state, [purchaseId])[0];
  return purchase ? purchase.line_items_count : 0;
};
